// extracted by mini-css-extract-plugin
export default {"device":"Device_device__+OyB-","accordion":"Device_accordion__ieclS","device_topics":"Device_device_topics__DFBna","device_info":"Device_device_info__5T8wY"};